/**
 * Shopify Meridian Theme Engine - Vanilla JS Controller
 * Replicates Next.js Meridian state management and interactive features
 */

document.addEventListener('DOMContentLoaded', () => {
  initSpotlightEffect();
  initLayoutSwitcher();
  initCountdownTimer();
  initCartDrawer();
  initSlidingLoginModal();
  initPolicyFaqModal();
  initRecipeBundle();
});

/* 1. Spotlight Mouse Glow Tracking */
function initSpotlightEffect() {
  const cards = document.querySelectorAll('.spotlight-card');
  cards.forEach((card) => {
    card.addEventListener('mousemove', (e) => {
      const rect = card.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      card.style.setProperty('--mouse-x', `${x}px`);
      card.style.setProperty('--mouse-y', `${y}px`);
    });
  });
}

/* 2. Home Layout Mode Switcher (Editorial / Bento / Boutique) */
function initLayoutSwitcher() {
  const buttons = document.querySelectorAll('.layout-switcher-btn');
  const heroSections = {
    editorial: document.getElementById('hero-editorial-section'),
    bento: document.getElementById('hero-bento-section'),
    boutique: document.getElementById('hero-boutique-section'),
  };

  buttons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const targetMode = btn.dataset.layout;
      buttons.forEach((b) => b.classList.remove('active'));
      btn.classList.add('active');

      Object.keys(heroSections).forEach((mode) => {
        if (heroSections[mode]) {
          if (mode === targetMode) {
            heroSections[mode].style.display = 'block';
          } else {
            heroSections[mode].style.display = 'none';
          }
        }
      });
    });
  });
}

/* 3. Real-Time Daily Flash Sale Countdown Timer */
function initCountdownTimer() {
  const hoursEl = document.getElementById('timer-hours');
  const minutesEl = document.getElementById('timer-minutes');
  const secondsEl = document.getElementById('timer-seconds');
  if (!hoursEl || !minutesEl || !secondsEl) return;

  // Set target to midnight tonight or 14h countdown
  let targetTime = new Date().getTime() + (14 * 60 * 60 * 1000 + 45 * 60 * 1000 + 12 * 1000);

  function updateClock() {
    const now = new Date().getTime();
    const diff = targetTime - now;

    if (diff <= 0) {
      hoursEl.textContent = '00';
      minutesEl.textContent = '00';
      secondsEl.textContent = '00';
      return;
    }

    const h = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const s = Math.floor((diff % (1000 * 60)) / 1000);

    hoursEl.textContent = String(h).padStart(2, '0');
    minutesEl.textContent = String(m).padStart(2, '0');
    secondsEl.textContent = String(s).padStart(2, '0');
  }

  updateClock();
  setInterval(updateClock, 1000);
}

/* 4. Slide-Out Cart Drawer & Shopify AJAX Cart */
function initCartDrawer() {
  const cartTrigger = document.querySelector('[data-cart-trigger]');
  const drawerPanel = document.getElementById('cart-drawer');
  const drawerBackdrop = document.getElementById('drawer-backdrop');
  const drawerClose = document.querySelectorAll('[data-cart-close]');

  function openCart() {
    if (drawerPanel) drawerPanel.classList.add('is-open');
    if (drawerBackdrop) drawerBackdrop.classList.add('is-open');
    fetchCartData();
  }

  function closeCart() {
    if (drawerPanel) drawerPanel.classList.remove('is-open');
    if (drawerBackdrop) drawerBackdrop.classList.remove('is-open');
  }

  if (cartTrigger) cartTrigger.addEventListener('click', openCart);
  drawerClose.forEach((btn) => btn.addEventListener('click', closeCart));
  if (drawerBackdrop) drawerBackdrop.addEventListener('click', closeCart);

  // Quick Add to cart delegator
  document.addEventListener('click', (e) => {
    const addBtn = e.target.closest('[data-add-to-cart]');
    if (addBtn) {
      e.preventDefault();
      const variantId = addBtn.dataset.variantId || addBtn.dataset.id;
      if (variantId) {
        addToCart(variantId, 1, () => {
          openCart();
        });
      }
    }
  });
}

function addToCart(variantId, quantity = 1, callback) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: quantity }] }),
  })
    .then((res) => res.json())
    .then((data) => {
      if (callback) callback(data);
    })
    .catch((err) => {
      console.log('Cart add mock/info:', err);
      if (callback) callback();
    });
}

function fetchCartData() {
  fetch('/cart.js')
    .then((res) => res.json())
    .then((cart) => {
      updateCartUI(cart);
    })
    .catch(() => {
      // Fallback for standalone preview
      updateCartUI({ item_count: 0, total_price: 0, items: [] });
    });
}

function updateCartUI(cart) {
  const badge = document.querySelector('.cart-badge');
  if (badge) badge.textContent = cart.item_count || 0;

  const countText = document.getElementById('cart-drawer-count');
  if (countText) countText.textContent = `(${cart.item_count || 0})`;

  const itemsContainer = document.getElementById('cart-drawer-items');
  const totalEl = document.getElementById('cart-drawer-total');

  if (totalEl) {
    const formattedPrice = (cart.total_price / 100).toFixed(2);
    totalEl.textContent = `$${formattedPrice}`;
  }

  if (!itemsContainer) return;

  if (!cart.items || cart.items.length === 0) {
    itemsContainer.innerHTML = `
      <div style="text-align: center; padding: 40px 0; color: #98A0AC;">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="margin-bottom: 12px; opacity: 0.5;">
          <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
          <line x1="3" y1="6" x2="21" y2="6"></line>
        </svg>
        <p style="font-weight: 600;">Your cart is empty</p>
        <p style="font-size: 13px;">Add fresh organic groceries to start shopping.</p>
      </div>
    `;
    return;
  }

  let html = '';
  cart.items.forEach((item) => {
    html += `
      <div style="display: flex; gap: 16px; align-items: center; padding: 12px 0; border-bottom: 1px solid #EAEBEF;">
        <img src="${item.featured_image.url}" alt="${item.product_title}" style="width: 60px; height: 60px; object-fit: contain; border-radius: 8px; background: #F7F8FA;">
        <div style="flex: 1;">
          <h4 style="margin: 0 0 4px; font-size: 14px; font-weight: 700;">${item.product_title}</h4>
          <p style="margin: 0; font-size: 13px; color: #12A06E; font-weight: 700;">$${(item.price / 100).toFixed(2)} x ${item.quantity}</p>
        </div>
      </div>
    `;
  });
  itemsContainer.innerHTML = html;
}

/* 5. Sliding Login & Register Panel */
function initSlidingLoginModal() {
  const modal = document.getElementById('sliding-login-modal');
  const trigger = document.querySelectorAll('[data-login-trigger]');
  const closeBtn = document.querySelectorAll('[data-login-close]');
  const switchBtns = document.querySelectorAll('[data-auth-switch]');
  const loginForm = document.getElementById('auth-login-form');
  const registerForm = document.getElementById('auth-register-form');

  trigger.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      if (modal) modal.classList.add('is-open');
    });
  });

  closeBtn.forEach((btn) => {
    btn.addEventListener('click', () => {
      if (modal) modal.classList.remove('is-open');
    });
  });

  switchBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const mode = btn.dataset.authSwitch;
      if (mode === 'register') {
        if (loginForm) loginForm.style.display = 'none';
        if (registerForm) registerForm.style.display = 'block';
      } else {
        if (registerForm) registerForm.style.display = 'none';
        if (loginForm) loginForm.style.display = 'block';
      }
    });
  });
}

/* 6. Policy / FAQ Seamless Modal */
function initPolicyFaqModal() {
  const modal = document.getElementById('policy-faq-modal');
  const triggers = document.querySelectorAll('[data-policy-trigger]');
  const closeBtns = document.querySelectorAll('[data-policy-close]');

  triggers.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      if (modal) modal.classList.add('is-open');
    });
  });

  closeBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      if (modal) modal.classList.remove('is-open');
    });
  });
}

/* 7. 1-Click Recipe Bundle Add To Cart */
function initRecipeBundle() {
  const bundleBtn = document.getElementById('recipe-bundle-buy-btn');
  if (!bundleBtn) return;

  bundleBtn.addEventListener('click', () => {
    const checkboxes = document.querySelectorAll('.recipe-ingredient-checkbox:checked');
    const items = [];
    checkboxes.forEach((cb) => {
      if (cb.dataset.variantId) {
        items.push({ id: parseInt(cb.dataset.variantId), quantity: 1 });
      }
    });

    if (items.length > 0) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      })
        .then(() => {
          const cartDrawer = document.getElementById('cart-drawer');
          const drawerBackdrop = document.getElementById('drawer-backdrop');
          if (cartDrawer) cartDrawer.classList.add('is-open');
          if (drawerBackdrop) drawerBackdrop.classList.add('is-open');
          fetchCartData();
        })
        .catch((err) => console.log('Bundle buy:', err));
    }
  });
}
